import React, { FC, ReactNode } from "react";
import { LinearGradient } from "react-text-gradients";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: ReactNode;
  subHeading: string;
  btnText: string;
}

const SectionHero: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  return (
    <div
      className={`nc-SectionHero relative ${className} mb-20 lg:mb-36`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        <div className="flex-grow">
          <img className="w-full  rounded-xl" src={rightImg} alt="" />
        </div>
        <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
            About Us
          </h2>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            At Autowurx, we are in the business of selling cars. Everyone at
            Autowurx is ready to make the car shopping and the car buying
            experience fast, friendly, and easy. We've helped hundreds of
            customers get behind the wheel of a newer, reliable, quality used
            vehicle and we can help you too. Located in Laurel, MD, we offer a
            convenient location to serve the region with like-new,
            well-maintained vehicles for all
          </span>
          {!!btnText && (
            <ButtonPrimary className="rounded-md" href="/signup">
              {btnText}
            </ButtonPrimary>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
